import { ArrowUpward, ArrowDownward, UnfoldMore } from '@material-ui/icons';
import './SortIcon.scss';

/** @typedef {'asc'|'desc'|undefined} SortType */

/**
 * @param {SortType} sortType
 */
const getSortIcon = (sortType) => {
    if (sortType === 'asc') return <div className="sort-type-icon"><ArrowUpward /></div>;
    if (sortType === 'desc') return <div className="sort-type-icon"><ArrowDownward /></div>;
    return <div className="sort-type-icon"><UnfoldMore /></div>;
};

export default getSortIcon;
